class VariantSelector extends HTMLElement {
  constructor() {
    super();
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  connectedCallback() {
    this.radioSelectors = this.querySelectorAll('input[type="radio"]');
    this.dropdownSelectors = this.querySelectorAll('select[name="variant-id"]');

    this.handleChange = this.handleChange.bind(this);

    this.radioSelectors.forEach((selector) => {
      selector.addEventListener('change', this.handleChange);
    })

    this.dropdownSelectors.forEach((selector) => {
      selector.addEventListener('change', this.handleChange);
    })
  }

  disconnectedCallback() {
    this.radioSelectors.forEach((selector) => {
      selector.removeEventListener('change', this.handleChange);
    })

    this.dropdownSelectors.forEach((selector) => {
      selector.removeEventListener('change', this.handleChange);
    })
  }

  handleChange(event) {
    const input = event.currentTarget;

    // get the Variant ID from the change of <input> or <select>
    // also render the section with Section API
    const url = `${window.location.pathname}?variant=${input.value}&section_id=${this.sectionId}`;

    fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        document.querySelector('#product-main').innerHTML = tempDiv.querySelector('#product-main').innerHTML;

        const newUrl = new URL(url, window.location.origin);
        newUrl.searchParams.delete('section_id');
        window.history.pushState({}, '', newUrl.toString());
      })
      .catch((error) => {
        console.log(error);
      })
  }
}

customElements.define('variant-selector', VariantSelector);
